export default 'prod-fucecchio'
